import { Platform } from "react-native";

const getBrowserNameFromUserAgent = () => {
  if (typeof navigator !== "undefined") {
    return navigator.userAgent.split(" ")[0] || "Unknown Browser";
  }
  return "Unknown Browser";
};

const getDeviceInfo = () => {
  if (Platform.isTV && Platform.OS === "ios") {
    return {
      device_name: "Apple TV",
      os_name: `tvOS ${Platform.Version}`,
    };
  }

  if (Platform.isTV && Platform.OS === "android") {
    return {
      device_name: "Android TV",
      os_name: `Android TV ${Platform.Version}`,
    };
  }

  if (Platform.OS === "ios") {
    return {
      device_name: "iPhone/iPad",
      os_name: `iOS ${Platform.Version}`,
    };
  }

  if (Platform.OS === "android") {
    return {
      device_name: "Android",
      os_name: `Android ${Platform.Version}`,
    };
  }

  if (Platform.OS === "web") {
    return {
      device_name: "Web",
      os_name: getBrowserNameFromUserAgent(),
    };
  }

  return {
    device_name: Platform.OS,
    os_name: Platform.OS,
  };
};

export default getDeviceInfo;
